export default {"src":"/_next/static/media/ico_heart-light.e87676d2.svg","height":46,"width":49};